export { FeaturedProjectSection } from './FeaturedProjectSection'
